import React from 'react'

import { Heading, useMediaQueryContext } from '@fourthwall/components'

import { DashboardSectionItem } from './DashboardSectionItem'
import { DashboardSectionScrollableContent } from './DashboardSectionScrollableContent'
import * as S from './styled'
import type { DashboardSectionProps } from './types'

export const DashboardSection = ({
  name,
  title,
  titleSpacing = 'small',
  toolbarContent,
  topContent,
  bottomContent,
  bottomMargin = 'medium',
  children,
}: DashboardSectionProps) => {
  const media = useMediaQueryContext()

  const renderNameContent = () => {
    if (!name && !toolbarContent) {
      return null
    }

    return (
      <S.NameContainer>
        <S.NameContent>
          {name && (
            <S.HeadingContainer>
              <Heading type={media.laptop ? 'h2' : 'h3'} asTag="h1" weight="semibold">
                {name}
              </Heading>
            </S.HeadingContainer>
          )}
          {toolbarContent && <S.ToolbarContainer>{toolbarContent}</S.ToolbarContainer>}
        </S.NameContent>
      </S.NameContainer>
    )
  }

  return (
    <S.Container>
      {(topContent || name || title || bottomContent || toolbarContent) && (
        <S.HeaderContainer $bottomMargin={bottomMargin}>
          {topContent && (
            <S.TopContainer data-testid="DashboardSection.TopContainer">
              {topContent}
            </S.TopContainer>
          )}
          {renderNameContent()}
          {title && (
            <S.TitleContainer $titleSpacing={titleSpacing}>
              <S.Title>{title}</S.Title>
            </S.TitleContainer>
          )}
          {bottomContent && <S.BottomContainer>{bottomContent}</S.BottomContainer>}
        </S.HeaderContainer>
      )}
      {children}
    </S.Container>
  )
}

DashboardSection.Item = DashboardSectionItem
DashboardSection.ScrollableContent = DashboardSectionScrollableContent
